module.exports = __webpack_public_path__ + "static/media/note1.572a8225.wav";